@let data = openDialogData();
@let isError = data.type === 'error';
@let isDanger = data.type === 'danger';
@let isWarning = data.type === 'warning';
@let title = data.title;
@let text = data.text;
@let details = data.details;
@let acceptLabel = data.acceptLabel;
@let rejectLabel = data.rejectLabel;
@let closeLabel = data.closeLabel;
@let ignoreReadOnly = data.ignoreReadOnly;
@let preserveTitleFormatting = data.preserveTitleFormatting;
@let id = data.id;
@let role = data.role;

<div
  class="cv-dialog-header"
  [class.cv-dialog-header-danger]="isDanger"
  [class.cv-dialog-header-error]="isError"
  [class.cv-dialog-header-warning]="isWarning"
  [id]="id"
>
  <div class="cv-dialog-header-heading">
    <app-icon
      [colour]="isDanger || isError ? COLOUR.red900 : isWarning ? COLOUR.yellow900 : COLOUR.primary900"
      [icon]="isDanger || isError ? ICON.XCircle : isWarning ? ICON.WarningTriangle : ICON.InfoCircle"
      [size]="21"
    />
    <h3 [attr.id]="role ? role + 'heading' : null">{{
      preserveTitleFormatting
        ? title
        : isEnglishTitle()
          ? (title | titlecase)
          : (title | lowercase | capitalizeFirstLetter)
    }}</h3>
  </div>
  <app-button
    small
    secondary
    borderless
    [danger]="isError"
    [aria]="{ label: closeLabel ?? (DEFAULT_CLOSE_LABEL | translateString) }"
    [icon]="ICON.X"
    [ignoreReadOnly]="true"
    (buttonClicked)="closeDialogData.emit('closed')"
  />
</div>

<div class="cv-dialog-content">
  <div [outerHTML]="text"></div>
  @if (details) {
    <p class="cv-dialog-content-details">{{ details }}</p>
  }
</div>

<div class="cv-dialog-footer">
  @if (rejectLabel) {
    <app-button
      secondary
      [danger]="isError"
      [ignoreReadOnly]="ignoreReadOnly"
      (buttonClicked)="closeDialogData.emit('rejected')"
    >
      {{ rejectLabel }}
    </app-button>
  }
  @if (acceptLabel) {
    <app-button
      #confirmButton
      dataCy="dialog-confirm-button"
      [autofocus]="true"
      [danger]="isError"
      [ignoreReadOnly]="ignoreReadOnly"
      (buttonClicked)="closeDialogData.emit('accepted')"
    >
      {{ acceptLabel }}
    </app-button>
  }
  @if (closeLabel) {
    <app-button
      [danger]="isError"
      [ignoreReadOnly]="ignoreReadOnly"
      (buttonClicked)="closeDialogData.emit('closed')"
      dataCy="dialog-confirm-button"
    >
      {{ closeLabel }}
    </app-button>
  }
</div>
